<template>
    <div class="child-choice-inner-container">
        <div
            class="child-choice-wrapper"
            :style="{ paddingLeft: level * 20 + 'px' }"
            @click.stop="updateValue(item)"
            :class="{
                selected: modelValue && item.value === modelValue.value,
                disable: !item.selectable,
            }"
        >
            <div class="child-choice">
                <img :src="chooseImage(item.type)" />
                <label :for="item.value"> {{ item.name }}</label>
            </div>
            <div
                class="check"
                v-if="modelValue && item.value === modelValue.value"
            >
                <i class="fa-solid fa-check"></i>
            </div>
        </div>

        <RecursiveItem
            v-for="item in item.children"
            :key="item.value"
            :item="item"
            v-model="selected"
            :level="level + 1"
            @bonjour="$emit('bonjour', $event)"
        />
    </div>
</template>

<script>
import RecursiveItem from "@/components/basic/RecursiveItem.vue"
export default {
    props: {
        item: {
            type: Array,
        },
        level: {
            type: Number,
        },
        image: {
            type: String,
        },
        modelValue: {},
    },
    components: {
        RecursiveItem,
    },
    data() {
        return {
            selected: null,
        }
    },
    methods: {
        updateValue() {
            if (this.item.selectable) {
                this.$emit("bonjour", this.item)
            }
        },

        chooseImage(value) {
            switch (value) {
                case 0:
                    return require("@/assets/images/buildings/complex-residence-medium.png")
                case 1:
                    return require("@/assets/images/buildings/simplified-residence-medium.png")
                case 2:
                    return require("@/assets/images/buildings/basic-residence-medium.png")
                case "CAGE":
                    return require("@/assets/images/buildings/stairwell-medium.png")
                case "BATIMENT":
                    return require("@/assets/images/buildings/building-medium.png")

                default:
                    return null
            }
        },
    },

    watch: {
        modelValue: {
            handler(newValue) {
                this.selected = newValue
            },
        },
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables/fontSize.scss";
@import "@/assets/scss/global.scss";

.child-choice-inner-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 0.4em;
    width: 100%;

    .child-choice-wrapper {
        width: 100%;
        display: flex;
        justify-content: space-between;
        gap: 1em;
        border-radius: 10px;
        transition: all ease-in-out 0.1s;
        padding: 0.2em 0;
        cursor: pointer;

        &:hover {
            transition: all ease-in-out 0.1s;
            background-color: $grey-light;
        }

        &.selected {
            transition: all ease-in-out 0.1s;
            background-color: $grey-dark;

            &:hover {
                background-color: $grey-dark;
            }
        }

        &.disable {
            cursor: default;
            background-color: $white;
            opacity: 0.4;

            &:hover {
                cursor: default !important;
                background-color: $white;
            }

            .child-choice {
                label,
                img {
                    &:hover {
                        cursor: default;
                    }
                }
            }
        }

        .child-choice {
            display: flex;
            align-items: center;
            gap: 1em;
            width: 80%;

            label {
                width: 100%;
                text-wrap: nowrap;
                padding: 0.4em 0;
                text-wrap: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                &:hover {
                    cursor: pointer;
                }

                font-size: $normal;
            }

            img {
                width: 25px;
                height: 25px;
                object-fit: contain;
            }
        }

        .check {
            display: flex;
            align-items: center;
            padding-right: 0.7em;
        }
    }
}
</style>
